"use client"

import { useEffect } from "react"

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error("[Horizon] Unhandled global error:", error, "digest:", error.digest)
  }, [error])

  return (
    <html lang="fr">
      <body>
        <div
          style={{
            display: "flex",
            minHeight: "100vh",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "1rem",
            padding: "1.5rem",
            textAlign: "center",
            fontFamily: "system-ui, sans-serif",
          }}
        >
          <h1 style={{ fontSize: "1.125rem", fontWeight: 600 }}>
            L&apos;application a rencontré une erreur critique
          </h1>
          <p style={{ fontSize: "0.875rem", color: "#666" }}>
            {error.message || "Erreur inattendue."}
          </p>
          {error.digest && (
            <p style={{ fontSize: "0.75rem", color: "#999" }}>Réf. {error.digest}</p>
          )}
          <button
            onClick={() => reset()}
            style={{
              padding: "0.5rem 1rem",
              borderRadius: "0.375rem",
              background: "#dc2626",
              color: "#fff",
              border: "none",
              cursor: "pointer",
            }}
          >
            Réessayer
          </button>
        </div>
      </body>
    </html>
  )
}
